import ElementModel from '../ElementModel.js';
import * as THREE from 'three';

let instance = null;

export default class ElementModelManager {
    constructor() {

        // Singleton
        if (instance) {
            return instance;
        }
        instance = this;
        this.elementModels = [];

    }

    addModel(elementModel) {
        this.elementModels.push(elementModel);
        //this.notifyUpdate();
    }

    async addModelAsync(elementModel)
    {
        return new Promise((resolve) => {
        this.elementModels.push(elementModel);
        resolve();
    });

    }

    getModels() {
        //console.log(this)
        //const models = instance.elementModels;
        //console.log(models)
        //models.forEach(model => console.log(model));

        return this.elementModels;
    }

    getModelById(id) {
        let idInt = parseInt(id);
        const mod = this.elementModels.find(elementModel => elementModel.id === idInt);
        
        return mod;
    }
    getModelByUuid(uuid) {


        const mod = this.elementModels.find(elementModel => elementModel.meshuuid === uuid);
        
        return mod;
    }

    getModelOverviewById(id) {
        let idInt = parseInt(id);
        const mod = this.elementModels.find(elementModel => elementModel.id === idInt);
        if(mod === undefined)
        {
            return undefined;
        }
    
        // Prepare the main overview object
        const overview = {
            ElementName: mod.name,
            ElementID: mod.mesh.uuid,
            ElementCategory: mod.category,
            ElementLinkedFile: mod.filePathName,
            Parameters: {}, // Group parameters by propertyset
        };
    
        // Add parameters dynamically, grouped by propertyset
        if (mod.parameters && Array.isArray(mod.parameters)) {
            mod.parameters.forEach(param => {
                const paramName = param.ParameterName; // Parameter name
                const propertySet = param.PropertySet || "General"; // Grouping header
                const paramValue = param.Value;
    
                // Group parameters under their propertyset
                if (!overview.Parameters[propertySet]) {
                    overview.Parameters[propertySet] = [];
                }
                overview.Parameters[propertySet].push({ name: paramName, value: paramValue });
            });
        }

        console.log(overview);
    
        return overview;
    }

    GetFileIdByPathName(filename){
        
        return this.elementModels.find(elementModel => elementModel.filePathName === filename).fileId;
    }

    GetCategoryGroupFileIdByPathName(category, id){
        
        return this.elementModels.filter(elementModel => elementModel.fileId === id && elementModel.category ===category);
    }

    GetConstructionElements(){
        
        return this.elementModels.filter(elementModel => elementModel.filetype === "Construction");
    }

    GetInstallationElements(){
        
        return this.elementModels.filter(elementModel => elementModel.filetype === "Installation");
    }

    ReturnMeshGroup()
    {


        const projectMeshes = this.elementModels;
        const meshgroup = new THREE.Group();

        projectMeshes.forEach(item =>
        {
            meshgroup.add(item.mesh);


        })


        return meshgroup;
    }



    removeModel(id) {
        this.elementModels = this.elementModels.filter(elementModel => elementModel.id !== id);
    }

    ModelIsPresent(id) {
        
        //let idInt = parseInt(id);
        //console.log(id)

        
        if(this.elementModels.find(elementModel => elementModel.meshuuid === id) === undefined)
        {
            
            return false;

        }
        else{
            return true;
        }
        
    }

    groupByFilename() {
        // Create a map to group elements by filename
        const grouped = this.elementModels.reduce((acc, element) => {
            const filename = element.filePathName;
            if (!acc[filename]) {
                acc[filename] = [];
            }
            acc[filename].push(element);
            return acc;
        }, {});
    
        // Convert the grouped object into an array of key-value pairs
        return Object.entries(grouped).map(([filename, elements]) => ({
            filename,
            elements
        }));
    }






    
}


